var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"8f57b333f4f0935687f554e0734893802b22bd26"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["we-are-oko@bond-coyne"]={id:"8f57b333f4f0935687f554e0734893802b22bd26"};
      